export default "__VITE_ASSET__CVpDYdQK__"